module.exports = __webpack_public_path__ + "site/img/renewen.190f1591.png";